<template>
  <div class="s-consent-view">
    <div class="s-consent-view__content" v-html="processedHtmlInfo" />
  </div>
</template>

<script>
import { inject, onMounted, reactive, toRefs, computed } from 'vue';
import api from '@/api';
import { fixTableAccessibility } from '@/utils/table-accessibility';

export default {
  name: 'consent-view',
  props: {
    agreementNo: {
      type: String,
    },
  },
  setup(props) {
    const toast = inject('toast');
    const state = reactive({
      frameRef: null,
      loading: true,
      detail: null,
    });

    const processedHtmlInfo = computed(() => {
      if (!state.detail?.htmlInfo) return '';
      return fixTableAccessibility(state.detail.htmlInfo);
    });

    onMounted(async () => {
      const [res1, ex1] = await api.consent.all(null, {
        agreementNo: props.agreementNo,
      });
      console.log('res1', res1, ex1);
      const [res, ex] = await api.consent.get(null, {
        agreementNo: props.agreementNo,
      });
      if (ex) {
        await toast.showEx(ex);
        return;
      }
      state.detail = res;
      state.loading = false;
    });
    return {
      ...toRefs(state),
      processedHtmlInfo,
    };
  },
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';
.s-consent-view {
  overflow-x: auto;
  &__content {
    display: block;
    margin: $space-80 auto;
    width: grid-width-m(10);
  }
  @include tablet-landscape {
    &__content {
      width: grid-width(20);
    }
  }
}
</style>
